module.exports = __webpack_public_path__ + "img/ind_iconBlk_03.1025f8c0.png";